import React, { useState } from 'react';
import { useLinkSettings } from '../context/LinkSettingsContext';
import './LinkSettings.css';

const LinkSettings = () => {
    const {
        watchLinks, addWatchLink, removeWatchLink, moveWatchUp, moveWatchDown,
        readLinks, addReadLink, removeReadLink, moveReadUp, moveReadDown
    } = useLinkSettings();

    const [watchName, setWatchName] = useState('');
    const [watchUrl, setWatchUrl] = useState('');
    const [readName, setReadName] = useState('');
    const [readUrl, setReadUrl] = useState('');

    const handleAddWatch = (e) => {
        e.preventDefault();
        if (watchName.trim() && watchUrl.trim()) {
            const success = addWatchLink(watchName, watchUrl);
            if (success) {
                setWatchName('');
                setWatchUrl('');
            }
        }
    };

    const handleAddRead = (e) => {
        e.preventDefault();
        if (readName.trim() && readUrl.trim()) {
            const success = addReadLink(readName, readUrl);
            if (success) {
                setReadName('');
                setReadUrl('');
            }
        }
    };

    const renderLinkList = (links, moveUp, moveDown, removeLink) => (
        <div className="links-list">
            {links.length === 0 ? (
                <p className="no-links">No links configured</p>
            ) : (
                links.map((link, index) => (
                    <div key={link.id} className="link-item">
                        <div className="link-info">
                            <span className="link-name">{link.name}</span>
                            <span className="link-url">{link.baseUrl}</span>
                        </div>
                        <div className="link-actions">
                            <button
                                className="move-btn move-up-btn"
                                onClick={() => moveUp(link.id)}
                                disabled={index === 0}
                                title="Move up"
                            >
                                ▲
                            </button>
                            <button
                                className="move-btn move-down-btn"
                                onClick={() => moveDown(link.id)}
                                disabled={index === links.length - 1}
                                title="Move down"
                            >
                                ▼
                            </button>
                            <button
                                className="remove-btn"
                                onClick={() => removeLink(link.id)}
                                title="Remove link"
                            >
                                ✕
                            </button>
                        </div>
                    </div>
                ))
            )}
        </div>
    );

    return (
        <div className="link-settings-container">
            <div className="link-settings-info">
                <h3>📌 How to Add Links</h3>
                <p>To add a new site shortcut:</p>
                <ol>
                    <li>Go to the website you want to add</li>
                    <li>Search for any anime/manga in the site's search box</li>
                    <li>Remove the anime/manga name you searched from the url and copy that url</li>
                    <li>Paste it below</li>
                </ol>
            </div>

            {/* Watch Links Section */}
            <div className="link-section">
                <h3>🎬 Watch Links</h3>
                {renderLinkList(watchLinks, moveWatchUp, moveWatchDown, removeWatchLink)}
                <form className="add-link-form" onSubmit={handleAddWatch}>
                    <input
                        type="text"
                        placeholder="Site name (e.g., Crunchyroll)"
                        value={watchName}
                        onChange={(e) => setWatchName(e.target.value)}
                        className="form-input"
                    />
                    <input
                        type="text"
                        placeholder="Paste search URL here"
                        value={watchUrl}
                        onChange={(e) => setWatchUrl(e.target.value)}
                        className="form-input"
                    />
                    <button type="submit" className="add-btn">
                        ➕ Add Watch Link
                    </button>
                </form>
            </div>

            {/* Read Links Section */}
            <div className="link-section">
                <h3>📖 Read Links</h3>
                {renderLinkList(readLinks, moveReadUp, moveReadDown, removeReadLink)}
                <form className="add-link-form" onSubmit={handleAddRead}>
                    <input
                        type="text"
                        placeholder="Site name (e.g., MANGA Plus)"
                        value={readName}
                        onChange={(e) => setReadName(e.target.value)}
                        className="form-input"
                    />
                    <input
                        type="text"
                        placeholder="Paste search URL here"
                        value={readUrl}
                        onChange={(e) => setReadUrl(e.target.value)}
                        className="form-input"
                    />
                    <button type="submit" className="add-btn">
                        ➕ Add Read Link
                    </button>
                </form>
            </div>
        </div>
    );
};

export default LinkSettings;
